<template>
  <footer
    class="bg-primary-tangerine h-10 flex items-center relative -z-10 overflow-hidden"
  >
    <nuxt-error-boundary @error="() => {}">
      <Swiper
        :space-between="0"
        slides-per-view="auto"
        :modules="[SwiperAutoplay]"
        :loop="true"
        :autoplay="{
          delay: 0
        }"
        :speed="5000"
        :free-mode="true"
        wrapper-class="!ease-linear"
        :allow-touch-move="false"
      >
        <SwiperSlide
          v-for="(slide, idx) in slides"
          :key="idx"
          class="!w-[auto]"
        >
          <div class="h-full flex flex-row">
            <!-- TODO: locale -->
            <div class="text-base font-bold mx-4">
              A NEW WAY TO DISCOVER YOUR STORY
            </div>
            <img
              alt="barnd logo black"
              src="/images/brand-logo-black.svg"
              class="object-cover object-center w-6 h-6"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </nuxt-error-boundary>
  </footer>
</template>

<script lang="ts" setup>
const slides = ref(
  Array.from({ length: 12 }, (index) => {
    return { index }
  })
)
</script>
